import { SelectOptionType } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import DisplayError from '../../components/info/DisplayError';
import { TranslationsKeys } from '../../locales/translations';
import { PaginationQueryDto } from '../../types/paginationRequestType';
import { StudentWarningsSummaryDataLoader } from './loaders/StudentWarningsSummaryDataLoader';
import { useWarningsSummaryFormLoaderData } from './loaders/StudentWarningsSummaryFormLoader';
import StudentWarningsSummaryFilters from './parts/StudentWarningsSummaryFilters';
import StudentWarningsSummaryTabs from './parts/StudentWarningsSummaryTabs';
import { StudentWarningsSummaryDataParams } from './types';

const defaultFilters: PaginationQueryDto<StudentWarningsSummaryDataParams> = {
  items_per_page: 10,
  page: 1,
  warningGroupType: 'summary',
  periodId: undefined,
  schoolId: undefined,
};

const StudentWarningsSummary = () => {
  const data = useWarningsSummaryFormLoaderData();
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_SUMMARY);

  const tabs = useMemo<SelectOptionType[]>(() => {
    const tabsItems = [...data.warningGroups];
    tabsItems.unshift({ label: t('summary'), value: 'summary' });
    return tabsItems;
  }, [data.warningGroups, t]);

  if (!data?.warningGroups?.length) {
    return (
      <div className="w-100 d-flex flex-wrap justify-content-center">
        <DisplayError textBody={t('noWarningGroups.description')} />
      </div>
    );
  }

  return (
    <div className="w-100 d-flex flex-wrap justify-content-center">
      <StudentWarningsSummaryDataLoader defaultQuery={defaultFilters}>
        <StudentWarningsSummaryFilters />
        <Container fluid>
          <Row>
            <Col xs={12}>
              <StudentWarningsSummaryTabs tabs={tabs} defaultTab={tabs[0]} />
            </Col>
          </Row>
        </Container>
      </StudentWarningsSummaryDataLoader>
    </div>
  );
};

export default StudentWarningsSummary;
